import { lazy } from 'react';

const Descriptions = lazy(() => import('./Descriptions'));

export { Descriptions };
